import { Icon } from "@iconify/react";
import { forwardRef } from "react";
import { Box } from "@material-ui/core";
import { BoxProps } from "@material-ui/core";
import type { IconifyIcon } from "@iconify/react";

export type IconifyProps = string | IconifyIcon;

type IconProps = BoxProps & {
  icon: IconifyProps;
};

export const Iconify = forwardRef<SVGElement, IconProps>(
  ({ icon, width = 20, sx, ...other }, ref) => (
    <Box ref={ref} component={Icon} icon={icon} sx={{ width, height: width, ...sx }} {...other} />
  )
);
